// ==============================
// GLOBAL.JS – Shopify storefront logic
// ==============================

// Focus handling and accessibility utilities
function getFocusableElements(t) {
  return Array.from(
    t.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((t) => {
  t.setAttribute("role", "button");
  t.setAttribute("aria-expanded", "false");
  if (t.nextElementSibling.getAttribute("id"))
    t.setAttribute("aria-controls", t.nextElementSibling.id);
  t.addEventListener("click", (e) => {
    e.currentTarget.setAttribute(
      "aria-expanded",
      !e.currentTarget.closest("details").hasAttribute("open")
    );
  });
  if (!t.closest("header-drawer"))
    t.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(t, e = t) {
  const i = getFocusableElements(t);
  const s = i[0];
  const n = i[i.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (e) => {
    if (e.target === t || e.target === n || e.target === s)
      document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (e) {
    if (e.code.toUpperCase() !== "TAB") return;
    if (e.target === n && !e.shiftKey) {
      e.preventDefault();
      s.focus();
    }
    if ((e.target === t || e.target === s) && e.shiftKey) {
      e.preventDefault();
      n.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  e.focus();
}

try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const keys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let lastFocused = null;
  let mouse = null;
  window.addEventListener("keydown", (e) => {
    if (keys.includes(e.code.toUpperCase())) mouse = false;
  });
  window.addEventListener("mousedown", () => {
    mouse = true;
  });
  window.addEventListener(
    "focus",
    () => {
      if (lastFocused) lastFocused.classList.remove("focused");
      if (!mouse) {
        lastFocused = document.activeElement;
        lastFocused.classList.add("focused");
      }
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((t) => {
    t.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((t) => {
    t.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((t) => t.pause());
  document.querySelectorAll("product-model").forEach((t) => {
    if (t.modelViewerUI) t.modelViewerUI.pause();
  });
}

function removeTrapFocus(t = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (t) t.focus();
}

function onKeyUpEscape(t) {
  if (t.code.toUpperCase() !== "ESCAPE") return;
  const e = t.target.closest("details[open]");
  if (!e) return;
  const i = e.querySelector("summary");
  e.removeAttribute("open");
  i.setAttribute("aria-expanded", false);
  i.focus();
}

// Quantity inputs
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((t) =>
      t.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(t) {
    t.preventDefault();
    const prevValue = this.input.value;
    if (t.target.name === "plus") this.input.stepUp();
    else this.input.stepDown();
    if (prevValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);

// Shopify helpers
function debounce(fn, delay) {
  let i;
  return (...args) => {
    clearTimeout(i);
    i = setTimeout(() => fn.apply(this, args), delay);
  };
}

function fetchConfig(t = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${t}`,
    },
  };
}

if (typeof window.Shopify === "undefined") window.Shopify = {};
Shopify.bind = function (fn, ctx) {
  return function () {
    return fn.apply(ctx, arguments);
  };
};

// ... (alle standaard Shopify global functies blijven hier hetzelfde) ...

// ============================================================================
// ✅ CUSTOM FIX – Prevent double Add-to-Cart on collection pages
// ============================================================================
(function () {
  if (window.__atcBound) return;
  window.__atcBound = true;

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-atc-custom]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (btn.dataset.adding === "true") return;
    btn.dataset.adding = "true";
    btn.disabled = true;

    try {
      const variantId = btn.dataset.productId;
      if (!variantId) throw new Error("Missing data-product-id");

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        console.warn("Add-to-Cart request failed:", res.status);
      }

      // Optional event for cart drawer refresh
      document.dispatchEvent(new CustomEvent("cart:updated"));

      const original = btn.innerHTML;
      btn.innerHTML = "✔️ Added!";
      setTimeout(() => (btn.innerHTML = original), 1200);
    } catch (err) {
      console.error("ATC error:", err);
    } finally {
      btn.dataset.adding = "false";
      btn.disabled = false;
    }
  });
})();
